import styled from "styled-components";
import React from "react";
import { COLORS } from "../contants/colors";
import { QUERIES } from "../contants/allConstants";
import { useTranslation } from "react-i18next";

const AddTextField = ({
  inputStyle = { position: "relative" },
  title,
  value,
  hint,
  children,
  onChange,
  onDelete,
}) => {
  const { i18n } = useTranslation();

  return (
    <Wrapper>
      <Title>{title}</Title>
      <div style={{ position: "relative" }}>
        <Input
          rows="5"
          placeholder={hint}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={inputStyle}
        />
        {children}
        <div
          style={{
            position: "absolute",
            top: "2.5px",
            right: (i18n.language === "ar") == "ltr" ? "5px" : "auto",
            left: (i18n.language === "ar") == "ltr" ? "auto" : "5px",
            height: "42px",
          }}
        >
          <Button onClick={onDelete}>
            <Icon src={require("../images/delete.svg").default} alt="" />
          </Button>
        </div>
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  color: ${COLORS.black56};
  margin-top: 10px;
  width: 100%;
`;
const Title = styled.p`
  font-family: "Din";
  font-size: 0.875rem;
  font-weight: 700;
  margin: 0;
  padding-bottom: 7px;
`;
const Input = styled.input`
  font-family: "IBM Plex Sans Arabic";
  width: 100%;
  border: 1px solid ${COLORS.gray100};
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 300;
  padding: 10px;

  &::placeholder {
    color: ${COLORS.gray400};
  }
  &:focus {
    outline-color: ${COLORS.lightBlue};
  }
`;

const Button = styled.button`
  border-radius: 6px;
  background-color: white;
  border: none;
  height: 35px;
  width: 52px;
  margin-right: 5px;
  &:focus {
    outline-color: ${COLORS.primary};
  }
  @media (${QUERIES.mobileAndDown}) {
    width: 100%;
  }
`;

const Icon = styled.img`
  width: 15px;
  height: 18px;
  object-fit: fill;
  cursor: pointer;
`;

export default AddTextField;
